function scroll() {
    const elBackToTopButton = document.querySelector('.back-to-top');

    // -------------------------- Stick Menu Bar & Back to Top
    const elTopLine = document.querySelector('.header');

    if (elTopLine) {
        window.onscroll = () => {
            if (document.body.scrollTop > elTopLine.offsetHeight || document.documentElement.scrollTop > elTopLine.offsetHeight) {
                document.body.classList.add("sticky")
            } else {
                document.body.classList.remove("sticky")
            }
            if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                elBackToTopButton.classList.add('back-to-top--show');
            } else {
                elBackToTopButton.classList.remove('back-to-top--show');
            }
        }
    }

    // --------------------------  Scroll to Top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    };

    elBackToTopButton.addEventListener('click', scrollToTop, false);

}

module.exports = {scroll}
